import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { SeasonsResponse } from '../models/seasons.model';

@Injectable({ providedIn: 'root' })
export class SeasonsService extends BaseApiService {
  getSeasons(
    origin: string,
    destination: string,
    passenger: string,
    railcard: string,
    startDate: string,
    endDate: string,
  ): Observable<SeasonsResponse> {
    const endpoint = `/seasons/${origin}/${destination}/${passenger}/${railcard}/${startDate}/${endDate}`;
    return this.get<SeasonsResponse>(endpoint);
  }
}
